import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { toast } from "sonner";
import { Logo } from "@/components/Logo";
import { Chrome, ShieldCheck, Zap, TrendingUp } from "lucide-react";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function Login() {
  const location = useLocation();

  useEffect(() => {
    if (location.state?.error) {
      toast.error(location.state.error);
    }
  }, [location.state]);

  const handleGoogleLogin = () => {
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="gos-canvas min-h-screen flex items-center justify-center px-4">
      <div className="w-full max-w-md fade-up">
        <div className="flex items-center justify-center mb-10">
          <Logo size="lg" />
        </div>

        <div className="gos-card p-8" style={{ background: "#0F2A47" }}>
          <p className="eyebrow mb-2">AEO Agency by Smart Marketer</p>
          <h1 className="font-display text-3xl font-semibold text-white mb-2">AEO Command Centre</h1>
          <p className="text-sm text-slate-400 mb-8">
            Sign in with your Smart Marketer Google account to access the pipeline.
          </p>

          <button
            data-testid="google-login-btn"
            onClick={handleGoogleLogin}
            className="w-full flex items-center justify-center gap-3 gos-gradient text-white font-semibold py-3.5 rounded-xl transition-transform hover:scale-[1.02] active:scale-[0.99]"
          >
            <Chrome className="w-5 h-5" />
            Continue with Google
          </button>

          <div className="mt-6 flex items-start gap-2 text-xs text-slate-400 bg-white/5 rounded-lg p-3 border border-white/5">
            <ShieldCheck className="w-4 h-4 text-emerald-400 shrink-0 mt-0.5" />
            <span>
              Access is restricted to <span className="text-slate-200 font-medium">@smartmarketer.com</span> and{" "}
              <span className="text-slate-200 font-medium">@3xfreedom.com</span> accounts. Other domains will be denied.
            </span>
          </div>

          <div className="grid grid-cols-2 gap-3 mt-6">
            <div className="flex items-center gap-2 text-xs text-slate-400">
              <TrendingUp className="w-4 h-4 text-indigo-400" /> Pipeline forecasting
            </div>
            <div className="flex items-center gap-2 text-xs text-slate-400">
              <Zap className="w-4 h-4 text-amber-400" /> Manual lead tracking
            </div>
          </div>
        </div>

        <p className="text-center eyebrow mt-6">aeo.smartmarketeragency.com</p>
      </div>
    </div>
  );
}
